import { comics } from "@/mocks/blcomics";

export default function Popular() {
  const top = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section id="popular" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">热门精选</p>
            <h2 className="mt-2 font-heading text-2xl text-foreground-900 md:text-4xl">高分口碑之作</h2>
          </div>
          <a href="#library" className="whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-600 transition hover:border-primary-400 hover:text-primary-600">
            查看全部作品
          </a>
        </div>

        <div className="mt-8 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-3 md:gap-5">
          {top.map((c) => (
            <article key={c.id} className="w-[168px] shrink-0 snap-start md:w-[196px]">
              <div className="group relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-200">
                <img
                  src={c.cover}
                  alt={`热门BL漫画《${c.title}》封面`}
                  title={`${c.title} BL漫画`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute right-2 top-2 whitespace-nowrap rounded-full bg-black/45 px-2 py-1 text-xs font-semibold text-amber-200 backdrop-blur">
                  <i className="ri-star-fill mr-0.5 text-amber-300" aria-hidden="true"></i>
                  {c.rating.toFixed(1)}
                </span>
              </div>
              <h3 className="mt-2.5 text-sm font-semibold text-foreground-900">{c.title}</h3>
              <p className="mt-0.5 text-xs text-foreground-500">
                {c.style} · {c.author}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}